module.exports = __webpack_public_path__ + "static/media/message05.f04c9d30.png";